import { logOut, updateLocalStorageToken } from "../../../../containers/resources/utils";
import AirlineService from "../../../../services/catalogs/AirlineService";

export const REQUEST_FETCH_AIRLINE = "REQUEST_FETCH_AIRLINE";
export const FETCH_AIRLINE_SUCCESS = "FETCH_AIRLINE_SUCCESS";
export const FETCH_AIRLINE_ERROR = "FETCH_AIRLINE_ERROR";
export const INITIAL_STATE_AIRLINE = "INITIAL_STATE_AIRLINE";

function requestFetchAirline() {
  return {
    type: REQUEST_FETCH_AIRLINE,
  };
}

function fetchAirlineSuccess(json) {
  return {
    type: FETCH_AIRLINE_SUCCESS,
    airline: json.data,
  };
}

function fetchAirlineError(json) {
  return {
    type: FETCH_AIRLINE_ERROR,
    error: json.data,
  };
}

export function initialStateAirline() {
  return {
    type: INITIAL_STATE_AIRLINE,
  };
}

export function fetchAirline(airline_id) {
  return (dispatch) => {
    dispatch(requestFetchAirline());
    return AirlineService.getAirline(airline_id).then((json) => {
      if (json.data.code === 200) {
        dispatch(fetchAirlineSuccess(json.data));
      } else if (json.data.code === 202) {
        updateLocalStorageToken(json.data.token);
        dispatch(fetchAirline(airline_id));
      } else if (json.data.code === 498) {
        logOut();
      } else {
        dispatch(fetchAirlineError(json.data));
      }
    });
  };
}
